import { render, staticRenderFns } from "./AdminMigrateRecipes.vue?vue&type=template&id=0c0a0ad1"
import script from "./AdminMigrateRecipes.vue?vue&type=script&lang=js"
export * from "./AdminMigrateRecipes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports